import { Size } from '../diagram/utils/common/size';
var GraphReziser = /** @class */ (function () {
    function GraphReziser(graphWidth, graphHeight) {
        this.graphWidth = graphWidth;
        this.graphHeight = graphHeight;
    }
    GraphReziser.prototype.resize = function (width, height, expand) {
        if (expand === void 0) { expand = false; }
        if (this.graphWidth >= width && this.graphHeight >= height && !expand) {
            return new Size(width, height);
        }
        if (height > width) {
            height = height / (width + 0.0);
            width = 1.0;
        }
        else {
            width = width / (height + 0.0);
            height = 1.0;
        }
        var newWidth = 0;
        var newHeight = 0;
        if (width > height) {
            newWidth = this.graphWidth;
            newHeight = this.graphWidth / width;
        }
        else {
            newHeight = this.graphHeight;
            newWidth = this.graphHeight / height;
        }
        if (newWidth <= this.graphWidth && newHeight <= this.graphHeight) {
            return new Size(newWidth, newHeight);
        }
        if (newWidth > this.graphWidth) {
            newHeight = newHeight / (newWidth / this.graphWidth);
            newWidth = this.graphWidth;
        }
        else {
            newWidth = newWidth / (newHeight / this.graphHeight);
            newHeight = this.graphHeight;
        }
        return new Size(newWidth, newHeight);
    };
    return GraphReziser;
}());
export { GraphReziser };
